/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Loading_LabelInputs */

const de_commons_loading_label = /** @type {(inputs: Commons_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird geladen…`)
};

/** @type {(inputs: Commons_Loading_LabelInputs) => LocalizedString} */
const en_commons_loading_label = de_commons_loading_label;

/**

* @param {Commons_Loading_LabelInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_loading_label = /** @type {((inputs?: Commons_Loading_LabelInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Loading_LabelInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_loading_label(inputs)
	return en_commons_loading_label(inputs)
});